export interface CurrentCategory {
  title: string
  slug: string
}
export interface MenuLobbyItem {
  title: string
  category: string
  imgSrc?: string
  icon?: string
  label?: string
  url?: string
  subUrl?: string
  text?: string
}

export interface GamesRequestPayload {
  prov?: string
  groups?: string
  search?: string
  limit?: number
  cats?: string
  paged?: number
  offset?: number
}

export interface GameItem {
  ID?: number
  title?: string
  img?: {
    mobile?: {
      url: string
    }
    thumbnail: {
      url: string
    }
    cover?: {
      url: string
    }
    banner?: {
      url: string
    }
  }
  group?: string[]
  category?: string[]
  provider?: string
  gameId?: string
  gameType?: string
  promotionPrevent?: boolean
  loginRequired?: boolean
  jackpot?: boolean
  newTab?: boolean
  tag?: string
  gameUrl?: string
  apiUrl?: string
  gameCode?: string
  textSearch?: string
  promotionPrevent100K?: boolean
  wallet?: string
  feature?: boolean
  order?: number
  gameName?: string
  link?: string
  maintenance?: boolean
  imgSrc?: string
  partner_game_id?: string
  partnerGameId?: string
  cats?: string
  icon?: string
  label?: string
  url?: string
}

export interface IndirectBettingItem {
  imgSrc: string
  title: string
  sub?: string
  description?: string
  url?: string
  img?: {
    thumbnail: {
      url: string
    }
  }
}

export interface LotteryCity {
  created_at?: string
  date?: string
  feature?: number
  id?: number
  name?: string
  region?: string
  code?: number
  label?: string
  value?: string | number
  status?: number
  time_release?: string
  updated_at?: string
  url_minhngoc?: string
  url_rss?: string
  url_source?: string
}
export interface LotteryFilter {
  region: LotteryCity | null
  date: Date
}

export interface Lottery {
  result: LotteryPrize
  title: string
}
export type LotteryPrize = Record<string, string | number | null>
export interface LotteryData {
  lottery: Lottery
  originalResult: LotteryPrize
}

export enum CategoryNames {
  LODE = 'lode'
}
export enum LabelNames {
  NEW = 'new'
}

export interface GameStatistic {
  gameId: string
  gameName?: string
}
